<div class="text-center">
    <button class="btn btn-primary" (click)="openLogin()">Subcribe Now</button>
</div>